import { PaginationV3Resource } from '../../types/paginations'

export const isPaginationV3Resource = (resource: any): resource is PaginationV3Resource => (
    typeof resource === 'object'
        && resource !== null
        && 'count' in resource
        && 'currentPage' in resource
)
